let muted = false;

export const AudioGate = {
  isMuted: () => muted,
  setMuted(value: boolean) {
    muted = value;
  },
  toggle() {
    muted = !muted;
    return muted;
  },
};
